import React from 'react';
import { useAccount } from '@/hooks/useAccount';
import { useUser } from '@repo/hooks/useUser';
import { MainView, NoAccessView } from '@repo/ui/Views';

import { POLICIES } from '@/lib/Authorization';

import WhitelistForAccountTable from '@/features/whitelist/components/WhitelistForAccountTable';
import SecurityTabNav from '../components/security/SecurityTabNav';

const IpWhitelist = () => {
  const account = useAccount();

  const user = useUser();

  return POLICIES['account_allowed_access_ips:index'](user) ? (
    <MainView title="Account Security: IP Whitelist">
      {/* <SecurityTabNav /> */}
      <WhitelistForAccountTable accountId={account?.id} />
    </MainView>
  ) : (
    <NoAccessView />
  );
};

export default IpWhitelist;
